import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'
import queryString from 'querystring'
let headers = {'Content-type': 'application/json'}

export default {
  // 获取
  queryMessageList (params) {
    return axios.get(`${backendUrl}/messages`, params)
  },
  // 获取
  queryAllMessageList (params) {
    return axios.get(`${backendUrl}/messages/all`, params)
  },
  // 修改状态
  putMessageState (params, query) {
    return axios.putArr(`${backendUrl}/messages?` + queryString.stringify(query), params)
  },
  // 删除
  deleteMessageState (params) {
    return axios.deleteArr(`${backendUrl}/messages`, params)
  },

  // 获取进度条 数据管理 导入、导出; 空间文件 移动、复制
  getProgress (params){
    return axios.get(`${backendUrl}/common/cache`, params)
  },

  // 获取进度条 数据管理 移动、复制
  getCommonProgress (params) {
    return axios.get(`${backendUrl}/messages/progress`, params)
  },

  // 上传文件通知
  postMessageUpload (params, query) {
    return axios.post(`${backendUrl}/messages/upload?` + queryString.stringify(query), params, headers)
  },

  // 获取是否有新分享消息
  getHasShareMessages (params) {
    return axios.get(`${backendUrl}/share/messages/received/unread`, params)
  },

  // 分享消息列表
  getReceivedShareMessages (params) {
    return axios.get(`${backendUrl}/share/messages/received`, params)
  },

  // 我的分享消息列表
  getSendedHasShareMessages (params) {
    return axios.get(`${backendUrl}/share/messages/sended`, params)
  },

  // 全部分享消息
  getAllShareMessages (params) {
    return axios.post(`${backendUrl}/share/messages?` + queryString.stringify(params), {})
  },

  // 删除分享消息
  deleteShareMessages (params) {
    return axios.delete(`${backendUrl}/share/messages`, params)
  },

  // 分享消息已读
  getShareMessagesRead (params) {
    return axios.get(`${backendUrl}/share/messages/${params.shareRelationId}`, {})
  },

  // 分享链接回调/backend
  getShareMessagesReadBack (params) {
    return axios.post(`${backendUrl}/share/person/read?` + queryString.stringify(params), {})
  },

  // 分享工程状态
  getShareMessagesState (params) {
    return axios.get(`${backendUrl}/share/message/valid?` + queryString.stringify(params), {})
  },

  // 获取邀请员工分享二维码链接信息
  getInvitationInfo (params) {
    let headers = {'Content-type': 'application/x-www-form-urlencoded'}
    return axios.post(`${backendUrl}/share/invitation`, params, headers)
  },

  // UGC申诉
  ugcAppeal (params) {
    // let headers = {'Content-type': 'application/x-www-form-urlencoded'}
    return axios.post(`${backendUrl}/ugc/appeal`, params)
  }
}
